import React, { Component } from 'react';
import GraficosMainPage from './graficos.page';
import WebapiCommon from '@common/util/webapi.common';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUsuarioLocalStorage } from '../../localStorage.util';
import * as actions from '@common/common.action';
import CommonFunctions from '@common/util/functions.common';

class GraficosMainContainer extends Component {
  constructor () {
    super();
    const periodo = CommonFunctions.getPeriodosSubDays();

    this.state = {
      data: [],
      cenario: undefined,
      periodode: periodo.periodoInicial,
      periodoate: periodo.periodoFinal
    };
  }

  componentDidMount () {
    let usuarioLocalStorage = getUsuarioLocalStorage();
    if (usuarioLocalStorage === null) {
      this.props.history.push('/' + process.env.REACT_APP_LOGINPAGE);
    } else {
      this.props.actions.showFadeCarregando(false);
      this.setState({
        usuario: usuarioLocalStorage
      });
    }
  }

  render () {
    return (
      <GraficosMainPage
        history={this.props.history}
        data={this.state.data}
        cenario={this.state.cenario}
        cenarioChange={this.cenarioChange.bind(this)}
        gerar={this.gerar.bind(this)}
        periodoChange={this.periodoChange.bind(this)}
        getDate={this.getDate.bind(this)}
        alerta={this.props.alerta}        
      />
    );
  }

  cenarioChange (valor) {
    this.setState({
      cenario: valor,
      data: []
    });
  }

  periodoChange (name, value) {
    this.setState({
      [name]: value
    });
  }

  getDate (name) {
    return this.state[name];
  }

  gerar () {
    if (this.state.cenario) {
      this.props.actions.showFadeCarregando(true);
    } else {
      this.props.actions.showAlerta('erro', 'Selecione um cenário', 2000);
    }
    if (this.state.cenario === '1') {
      WebapiCommon.getLaudosLiberadosParaGrafico(
        this.state.periodode,
        this.state.periodoate
      ).then(laudos => {
        this.props.actions.showFadeCarregando(false);
        this.setState({
          data: laudos.data
        });
      });
    }

    if (this.state.cenario === '2') {
      Promise.all([
        WebapiCommon.getTotalNaoConformidadesPorEtapa(
          this.state.periodode,
          this.state.periodoate
        )
      ]).then(response => {
        this.props.actions.showFadeCarregando(false);
        this.setState({
          data: response[0].data
        });
      });
    }

    if (this.state.cenario === '3') {
      WebapiCommon.getTempoMedioEtapas(
        this.state.periodode,
        this.state.periodoate
      ).then(etapas => {
        this.props.actions.showFadeCarregando(false);
        this.setState({
          data: etapas.data
        });
      });
    }

    if (this.state.cenario === '4') {
      WebapiCommon.getCancelamentosEtapas(
        this.state.periodode,
        this.state.periodoate
      ).then(etapas => {
        this.props.actions.showFadeCarregando(false);
        this.setState({
          data: etapas.data
        });
      });
    }

    if (this.state.cenario === '5') {
      WebapiCommon.getGraficoProdutividadeMaterial(
        this.state.periodode,
        this.state.periodoate
      ).then(response => {
        this.BuildDataGraficoProdutividade(response);
        this.props.actions.showFadeCarregando(false);
      });
    }

    if (this.state.cenario === '6') {
      WebapiCommon.getGraficoProdutividadeMapa(
        this.state.periodode,
        this.state.periodoate
      ).then(response => {
        this.BuildDataGraficoProdutividade(response);
        this.props.actions.showFadeCarregando(false);
      });
    }
  }

  BuildDataGraficoProdutividade (response) {
    try {
      let data = {};
      data.dataKey = response.data.dataKey;
      data.data = [];
      response.data.data.forEach(el => {
        let item = {
          name: el.name
        };
        el.colunm.forEach(e => {
          item = { ...item, ...e };
        });
        data.data.push(item);
      });
      this.setState({
        data: data
      });
    } catch (error) {
      this.props.actions.showFadeCarregando(false);
      this.props.actions.showAlerta('erro', 'teste', 2000);
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GraficosMainContainer);



// WEBPACK FOOTER //
// ./src/pages/graficos/graficos.container.js